// 解决唱吧 APP 内，安卓不支持前进后退的问题

import commonObj from 'commonObj';
import Router from 'vue-router';

if (!commonObj.data.outChangbaNew && commonObj.browser.isAndroid && window.changbaCaller?.addUrlCache) {
  // 拦截编程式导航
  const oldPush = Router.prototype.push;

  Router.prototype.push = function(location, onComplete, onAbort) {
    window.changbaCaller.addUrlCache(window.location.href);

    return oldPush.call(this, location, onComplete, onAbort);
  };
}

export default {
  addUrlCache(url = '') {
    window.changbaCaller?.addUrlCache?.(url || window.location.href);
  }
}
